import { recordHook } from '@flatfile/plugin-record-hook'
import { format, isValid, isBefore } from 'date-fns'
import { parseDateFromString, convertToUppercase } from 'utils'

const numericRegex = /[0-9]/g

/* The folowings are product specific formattings and validations for Uncashed Checks
  any formatting or validation specific to uncashed checks should be added here
*/

export const dateOfOriginalDistributionFormattingListener = (
  listener,
  sheetSlug
) => {
  listener.use(
    recordHook(sheetSlug, (record) => {
      const dateOfOriginalDistribution = record.get(
        'dateOfOriginalDistribution'
      )
      if (dateOfOriginalDistribution) {
        const dateofdistribution = parseDateFromString(
          dateOfOriginalDistribution.trim()
        )
        let formattedDofDistribution = dateOfOriginalDistribution

        if (dateofdistribution) {
          formattedDofDistribution = format(dateofdistribution, 'yyyy/MM/dd')
        } else {
          const sanitizedDofdistribution = dateOfOriginalDistribution
            .match(numericRegex)
            ?.join('')
          if (sanitizedDofdistribution) {
            formattedDofDistribution = sanitizedDofdistribution.replace(
              /(\d{4})(\d{1,2})(\d{2})/,
              '$1/$2/$3'
            )
          }
        }
        record.set('dateOfOriginalDistribution', formattedDofDistribution)
      }
      return record
    })
  )
}

export const wasTaxWithheldFormattingListener = (listener, sheetSlug) => {
  listener.use(
    recordHook(sheetSlug, (record) => {
      const wasTaxWithheld = record.get('wasTaxWithheld')
      if (wasTaxWithheld) {
        record.set('wasTaxWithheld', convertToUppercase(wasTaxWithheld))
      }
      return record
    })
  )
}

export const dateOfOriginalDistributionValidationListener = (
  listener,
  sheetSlug
) => {
  listener.use(
    recordHook(sheetSlug, (record) => {
      const dateOfOriginalDistribution = record.get(
        'dateOfOriginalDistribution'
      )
      if (dateOfOriginalDistribution) {
        const dateofDistributionDate = new Date(dateOfOriginalDistribution)
        if (isValid(dateofDistributionDate)) {
          const currentDate = new Date()
          const maxDate = new Date(currentDate)
          maxDate.setFullYear(currentDate.getFullYear() - 100)
          if (isBefore(dateofDistributionDate, maxDate)) {
            record.addError(
              'dateOfOriginalDistribution',
              'Must be under 100 years.'
            )
          }
        } else {
          const dateRe = new RegExp('^[0-9]{4}/[0-9]{1,2}/[0-9]{2}$')
          dateRe.test(dateOfOriginalDistribution)
            ? record.addError(
                'dateOfOriginalDistribution',
                'Must be a valid date'
              )
            : record.addError(
                'dateOfOriginalDistribution',
                'Format must be single-digit M if applicable, otherwise YYYY/MM/DD'
              )
        }
      }
      return record
    })
  )
}

export const wasTaxWithheldValidationListener = (listener, sheetSlug) => {
  listener.use(
    recordHook(sheetSlug, (record) => {
      const wasTaxWithheld = record.get('wasTaxWithheld')
      const traditionalIraPreTaxAmount = record.get(
        'traditionalIraPreTaxAmount'
      )
      if (!wasTaxWithheld) {
        if (traditionalIraPreTaxAmount) {
          record.addError('wasTaxWithheld', 'Required.')
        }
      }
      return record
    })
  )
}
